import React from 'react'

const EfficiencyLinearProgressItem = ({title,value , progress, color}) => {
    return (
        <div className='row c-linear-graph'>
            <div className="col-7 p-0 m-0"><span>{title}</span></div>
            <div className="col-5 p-0 m-0">
                <p className="float-end p-0 m-0 d-flex justify-content-end linear-progress"
                    style={{ backgroundColor: color,borderRadius: 24, width: (`${progress}%`) }}>
                    <span className="me-2">{value}</span></p>
            </div>
            <hr className='m-0 mt-1 mb-1'/>
        </div>
    )
}
export default EfficiencyLinearProgressItem;
